/**
 * Pagina standalone per la rotta /vendite/:id.
 * Wraps VenditaDetailContent estraendo `id` da useParams.
 */
import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import VenditaDetailContent from "@/pages/VenditaDetail";

export default function VenditaPage() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  // Sprint MENU-LATERALE — ?tipo= solo per l'evidenza del menu; mai riscritto se già presente
  const segnaTipo = (v) => {
    const qs = new URLSearchParams(location.search);
    if (qs.has("tipo") || !v?.tipo) return;
    qs.set("tipo", v.tipo);
    navigate({ pathname: location.pathname, search: `?${qs}` }, { replace: true });
  };
  return <VenditaDetailContent venditaId={id} onLoaded={segnaTipo} />;
}
